import { registerComponent as S } from "@aileron/icon";
import { unsafeCSS as x, LitElement as C } from "lit";
import { unsafeStatic as z, html as D } from "lit/static-html.js";
import { query as V, state as E, property as l } from "lit/decorators.js";
import { classMap as h } from "lit/directives/class-map.js";
import { ifDefined as w } from "lit/directives/if-defined.js";
import { live as k } from "lit/directives/live.js";
const $ = (o) => {
  class e extends o {
    constructor(...t) {
      super(...t), this.fontLink = "https://www.aa.com/fonts/css?family=american-sans-variable";
      const r = document.head || document.getElementsByTagName("head")[0];
      if (Array.from(r.getElementsByTagName("link")).findIndex(
        (c) => c.href === this.fontLink
      ) === -1) {
        const c = document.createElement("link");
        c.href = this.fontLink, c.rel = "stylesheet", document.head.appendChild(c);
      }
    }
  }
  return e;
}, L = `*,:before,:after{box-sizing:border-box;border-width:0;border-style:solid;border-color:currentColor}:before,:after{--tw-content: ""}html{line-height:1.5;-webkit-text-size-adjust:100%;-moz-tab-size:4;-o-tab-size:4;tab-size:4;font-family:AmericanSans Var,Helvetica,Arial,sans-serif;font-feature-settings:normal;font-variation-settings:normal}body{margin:0;line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-feature-settings:inherit;font-variation-settings:inherit;font-size:100%;font-weight:inherit;line-height:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,[type=button],[type=reset],[type=submit]{-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{list-style:none;margin:0;padding:0}dialog{padding:0}textarea{resize:vertical}input::-moz-placeholder,textarea::-moz-placeholder{opacity:1;color:#9ca3af}input::placeholder,textarea::placeholder{opacity:1;color:#9ca3af}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}[hidden]{display:none}*,:before,:after{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: }::backdrop{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: }.container{width:100%}@media (min-width: 24.375rem){.container{max-width:24.375rem}}@media (min-width: 50rem){.container{max-width:50rem}}@media (min-width: 80rem){.container{max-width:80rem}}@media (min-width: 90rem){.container{max-width:90rem}}.pointer-events-none{pointer-events:none}.static{position:static}.absolute{position:absolute}.relative{position:relative}.left-0{left:0}.left-1{left:.25rem}.left-\\[5px\\]{left:5px}.top-0{top:0}.top-1{top:.25rem}.top-\\[5px\\]{top:5px}.m-0{margin:0}.ml-0{margin-left:0}.ml-2{margin-left:.5rem}.mr-0{margin-right:0}.mr-2{margin-right:.5rem}.inline{display:inline}.inline-flex{display:inline-flex}.h-6{height:1.5rem}.h-8{height:2rem}.h-\\[22px\\]{height:22px}.w-6{width:1.5rem}.w-8{width:2rem}.w-\\[22px\\]{width:22px}.cursor-pointer{cursor:pointer}.appearance-none{-webkit-appearance:none;-moz-appearance:none;appearance:none}.flex-row-reverse{flex-direction:row-reverse}.items-center{align-items:center}.justify-center{justify-content:center}.rounded{border-radius:.25rem}.bg-blue-070{background-color:#0a78f5}.bg-neutral-000{background-color:#101419}.bg-neutral-010{background-color:#181e25}.bg-neutral-020{background-color:#202832}.bg-neutral-030{background-color:#28323e}.bg-neutral-110{background-color:#eceff3}.bg-neutral-120{background-color:#f3f5f7}.bg-neutral-130{background-color:#f9fafb}.bg-neutral-140{background-color:#fff}.pr-2{padding-right:.5rem}.font-sans{font-family:AmericanSans Var,Helvetica,Arial,sans-serif}.text-base{font-size:1rem}.leading-6{line-height:1.5rem}.text-blue-060{color:#0860c4}.text-blue-070{color:#0a78f5}.text-blue-080{color:#3b93f7}.text-neutral-010{color:#181e25}.text-neutral-050{color:#405164}.text-neutral-070{color:#637e9c}.text-neutral-090{color:#b4c1cf}.text-neutral-130{color:#f9fafb}.text-red-060{color:#cd1d32}.text-red-080{color:#e96776}.opacity-0{opacity:0}.opacity-100{opacity:1}.outline-none{outline:2px solid transparent;outline-offset:2px}.outline{outline-style:solid}.outline-2{outline-width:2px}.outline-offset-2{outline-offset:2px}.outline-blue-070{outline-color:#0a78f5}.blur{--tw-blur: blur(8px);filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.transition-\\[color\\]{transition-property:color;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.transition-\\[opacity\\,color\\]{transition-property:opacity,color;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.duration-\\[180ms\\]{transition-duration:.18s}.ease-in-out{transition-timing-function:cubic-bezier(.4,0,.2,1)}.font-normal{font-weight:400;font-variation-settings:"wght" 400}[hidden]{display:none!important}.hover\\:bg-blue-070:hover{background-color:#0a78f5}.hover\\:bg-neutral-110:hover{background-color:#eceff3}.hover\\:bg-neutral-120:hover{background-color:#f3f5f7}.hover\\:bg-neutral-130:hover{background-color:#f9fafb}.hover\\:text-blue-070:hover{color:#0a78f5}:is(:host([aileron-color-scheme=dark]) .dark\\:bg-neutral-000){background-color:#101419}:is(:host([aileron-color-scheme=dark]) .dark\\:bg-neutral-010){background-color:#181e25}:is(:host([aileron-color-scheme=dark]) .dark\\:bg-neutral-020){background-color:#202832}:is(:host([aileron-color-scheme=dark]) .dark\\:text-blue-080){color:#3b93f7}:is(:host([aileron-color-scheme=dark]) .dark\\:text-neutral-050){color:#405164}:is(:host([aileron-color-scheme=dark]) .dark\\:text-neutral-130){color:#f9fafb}:is(:host([aileron-color-scheme=dark]) .dark\\:text-red-080){color:#e96776}:is(:host([aileron-color-scheme=dark]) .dark\\:hover\\:bg-neutral-010:hover){background-color:#181e25}:is(:host([aileron-color-scheme=dark]) .dark\\:hover\\:bg-neutral-020:hover){background-color:#202832}:is(:host([aileron-color-scheme=dark]) .dark\\:hover\\:bg-neutral-030:hover){background-color:#28323e}:is(:host([aileron-color-scheme=dark]) .hover\\:dark\\:text-blue-070):hover{color:#0a78f5}
`, A = x(L), u = "aileron-color-scheme", v = "aileron-color-scheme-change", P = (o) => {
  class e extends o {
    constructor() {
      super(...arguments), this.handleSchemeSwitch = (t) => {
        t.detail ? this.setAttribute(u, t.detail) : this.removeAttribute(u);
      };
    }
    /**
     * Init web component with listener for theme changes, and gets current theme state.
     */
    connectedCallback() {
      super.connectedCallback(), document.documentElement.addEventListener(
        v,
        this.handleSchemeSwitch,
        {
          passive: !0
        }
      );
      const t = document.documentElement.getAttribute(
        u
      );
      t && this.setAttribute(u, t);
    }
    disconnectedCallback() {
      super.disconnectedCallback(), document.documentElement.removeEventListener(
        v,
        this.handleSchemeSwitch
      );
    }
  }
  return e.styles = [
    A,
    o.styles ?? []
  ], e;
}, F = P($(C));
function m(o, e) {
  function i(t) {
    if (!t || t === document || t === window)
      return null;
    t.assignedSlot && (t = t.assignedSlot);
    const r = t.closest(o);
    return r || i(t.getRootNode().host);
  }
  return i(e);
}
function p(o, e, i) {
  const t = new CustomEvent(e, {
    bubbles: !0,
    cancelable: !1,
    composed: !0,
    detail: {},
    ...i
  });
  return o.dispatchEvent(t), t;
}
class T extends Event {
  constructor(e) {
    super("formdata"), this.formData = e;
  }
}
class U extends FormData {
  constructor(e) {
    super(e), this.form = e, e.dispatchEvent(new T(this));
  }
  append(e, i) {
    let t = this.form.elements[e];
    if (t || (t = document.createElement("input"), t.type = "hidden", t.name = e, this.form.appendChild(t)), this.has(e)) {
      const r = this.getAll(e), s = r.indexOf(t.value);
      s !== -1 && r.splice(s, 1), r.push(i), this.set(e, r);
    } else
      super.append(e, i);
    t.value = i;
  }
}
function B() {
  const o = document.createElement("form");
  let e = !1;
  return document.body.append(o), o.addEventListener("submit", (i) => {
    new FormData(i.target), i.preventDefault();
  }), o.addEventListener("formdata", () => e = !0), o.dispatchEvent(new Event("submit", { cancelable: !0 })), o.remove(), e;
}
function y() {
  !window.FormData || B() || (window.FormData = U, window.addEventListener("submit", (o) => {
    o.defaultPrevented || new FormData(o.target);
  }));
}
document.readyState === "complete" ? y() : window.addEventListener("DOMContentLoaded", () => y());
class N {
  constructor(e, i) {
    (this.host = e).addController(this), this.options = {
      form: (t) => m("form", t),
      name: (t) => t.name,
      value: (t) => t.value,
      disabled: (t) => t.disabled,
      reportValidity: (t) => typeof t.reportValidity == "function" ? t.reportValidity() : !0,
      ...i
    }, this.options.form(this.host) && (this.options.form(this.host).noValidate = !0), this.handleFormData = this.handleFormData.bind(this), this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }
  hostConnected() {
    this.form = this.options?.form(this.host), this.form && (this.form.addEventListener("formdata", this.handleFormData), this.form.addEventListener("submit", this.handleFormSubmit));
  }
  hostDisconnected() {
    this.form && (this.form.removeEventListener("formdata", this.handleFormData), this.form.removeEventListener("submit", this.handleFormSubmit), this.form = void 0);
  }
  handleFormData(e) {
    const i = this.options.disabled(this.host), t = this.options.name(this.host), r = this.options.value(this.host);
    !i && typeof t == "string" && typeof r < "u" && (Array.isArray(r) ? r.forEach((s) => {
      e.formData.append(t, s.toString());
    }) : e.formData.append(t, r.toString()));
  }
  handleFormSubmit(e) {
    const i = this.options.disabled(this.host);
    this.form && !i && (e.preventDefault(), e.stopImmediatePropagation());
  }
  submit(e) {
    if (this.form) {
      const i = document.createElement("button");
      i.type = "submit", i.style.position = "absolute", i.style.width = "0", i.style.height = "0", i.style.clipPath = "inset(50%)", i.style.overflow = "hidden", i.style.whiteSpace = "nowrap", e && ["formaction", "formmethod", "formnovalidate", "formtarget"].forEach((t) => {
        e.hasAttribute(t) && i.setAttribute(t, e.getAttribute(t));
      }), this.form.append(i), i.click(), i.remove();
    }
  }
}
function b(o, e) {
  const i = {
    waitUntilFirstUpdate: !1,
    ...e
  };
  return (t, r) => {
    const { update: s } = t;
    if (o in t) {
      const d = o;
      t.update = function(c) {
        if (c.has(d)) {
          const f = c.get(d), g = this[d];
          f !== g && (!i.waitUntilFirstUpdate || this.hasUpdated) && this[r](
            f,
            g
          );
        }
        s.call(this, c);
      };
    }
  };
}
const j = `:host(.adc-checkbox[orientation="horizontal"]){margin-right:1rem}:host([orientation="horizontal"]:last-child){margin-right:0}:host([orientation="horizontal"][label-position="left"]){margin-left:1rem;margin-right:0}:host([orientation="horizontal"][label-position="left"]:first-child){margin-left:0}:host(.adc-checkbox[orientation="vertical"]){display:flex;flex-direction:column;height:auto;margin-bottom:.5rem}:host([orientation="vertical"]:last-child){margin-bottom:0}:host([checked]:not([invalid]):not([disabled])) input:hover~.adc-icon{color:#0a78f5}
`;
var M = Object.defineProperty, O = Object.getOwnPropertyDescriptor, a = (o, e, i, t) => {
  for (var r = t > 1 ? void 0 : t ? O(e, i) : e, s = o.length - 1, d; s >= 0; s--)
    (d = o[s]) && (r = (t ? d(e, i, r) : d(r)) || r);
  return t && r && M(e, i, r), r;
};
class n extends F {
  constructor(e) {
    super(), this.formSubmitController = new N(this, {
      value: (i) => i.checked ? i.value : void 0
    }), this.hasFocus = !1, this.pristine = !0, this.checked = !1, this.required = !1, this.disabled = !1, this.invalid = !1, this.indeterminate = !1, this.orientation = "horizontal", this.labelPosition = "right", this.labelText = "", this.liveValidation = !1, this.customElementString = e;
  }
  async connectedCallback() {
    super.connectedCallback(), this.classList.add("adc-checkbox"), S(
      this.customElementString ? this.customElementString + "-checkbox" : "adc-checkbox"
    );
  }
  firstUpdated() {
    this.invalid = !this.pristine && !this.input.checkValidity();
  }
  updated(e) {
    e.has("pristine") && this.liveValidation && !this.pristine && (this.invalid = !this.input.checkValidity()), e.has("disabled") && (this.disabled ? this.input.setAttribute("disabled", "disabled") : this.input.removeAttribute("disabled"));
  }
  /**
   * Click method for the checkbox.
   */
  click() {
    this.input.click();
  }
  /**
   * Focus method for the checkbox.
   */
  focus(e) {
    this.input.focus(e);
  }
  /**
   * Blur method for the checkbox.
   */
  blur() {
    this.input.blur();
  }
  /**
   * Check validity method for the checkbox.
   */
  reportValidity() {
    return this.input.reportValidity();
  }
  /**
   * Sets the custom validity message of the checkbox.
   */
  setCustomValidity(e) {
    this.input.setCustomValidity(e), this.invalid = !this.input.checkValidity();
  }
  /**
   * handleClick method for the checkbox.
   */
  handleClick() {
    this.checked = !this.checked, this.indeterminate = !1, this.handleValidity(), p(this, "adc-changed");
  }
  /**
   * handleBlur method for the checkbox.
   */
  handleBlur() {
    this.hasFocus = !1, p(this, "adc-blur");
  }
  handleDisabledChange() {
    this.input.disabled = this.disabled, this.invalid = !this.input.checkValidity();
  }
  /**
   * handleFocus method for the checkbox.
   */
  handleFocus() {
    this.hasFocus = !0, p(this, "adc-focus");
  }
  handleStateChange() {
    this.invalid = !this.input.checkValidity();
  }
  /**
   * handleValidity method for the checkbox.
   */
  handleValidity() {
    this.liveValidation && (this.pristine = !1), this.invalid = !this.input.checkValidity();
  }
  createTagName(e) {
    return z(
      this.customElementString ? this.customElementString + e : "adc" + e
    );
  }
  render() {
    const e = {
      "flex-row-reverse": this.labelPosition === "left",
      "pointer-events-none": this.disabled,
      rounded: this.hasFocus,
      "outline-offset-2": this.hasFocus,
      "outline-2": this.hasFocus,
      outline: this.hasFocus,
      "outline-blue-070": this.hasFocus
    }, i = !!m(".container-secondary", this), t = !!m(".container-tertiary", this);
    return D` <label
      part="base"
      for="checkbox"
      class="
        font-sans
        font-normal
          leading-6
        text-base
        group
        min-h-12
        cursor-pointer
        items-center
        inline-flex
        pr-2
        ${h(e)}
      "
    >
      <div
        class="
        h-8
        w-8
        relative
        ${h({
      "ml-2": this.labelPosition === "left",
      "mr-0": this.labelPosition === "left",
      "ml-0": this.labelPosition === "right",
      "mr-2": this.labelPosition === "right"
    })}
        "
      >
        <input
          part="input"
          id="checkbox"
          type="checkbox"
          class="
            relative
            left-1
            top-1
            inline-flex
            items-center
            justify-center
            appearance-none
            outline-none
            cursor-pointer
            min-w-6
            h-6
            w-6
            m-0
            ${h({
      "bg-neutral-120": t,
      "dark:bg-neutral-020": t,
      "hover:bg-neutral-110": t,
      "dark:hover:bg-neutral-030": t,
      "bg-neutral-130": i,
      "dark:bg-neutral-010": i,
      "hover:bg-neutral-120": i,
      "dark:hover:bg-neutral-020": i,
      "bg-neutral-140": !t && !i,
      "dark:bg-neutral-000": !t && !i,
      "hover:bg-neutral-130": !t && !i,
      "dark:hover:bg-neutral-010": !t && !i,
      "hover:bg-blue-070": this.checked && !this.disabled && !this.invalid
    })}
          "
          name=${w(this.name)}
          value=${w(this.value)}
          .indeterminate=${k(this.indeterminate)}
          .checked=${k(this.checked)}
          .required=${this.required}
          aria-checked=${this.checked ? "true" : "false"}
          @click=${this.handleClick}
          @blur=${this.handleBlur}
          @focus=${this.handleFocus}
        />
        <div
          class="
          pointer-events-none
          absolute
          left-[5px]
          top-[5px]
          w-[22px]
          h-[22px]
        "
        ></div>
        <${this.createTagName("-checkbox-icon")}
          icon="action:select-empty"
          size="32"
          class="
            pointer-events-none
            absolute
            left-0
            top-0
            z-1
            transition-[color]
            duration-[180ms]
            ease-in-out
            text-neutral-070
            ${h({
      "text-neutral-090": this.disabled,
      "dark:text-neutral-050": this.disabled,
      "text-red-060": this.invalid,
      "dark:text-red-080": this.invalid
    })}
          "
        ></${this.createTagName("-checkbox-icon")}>
        <${this.createTagName("-checkbox-icon")}
          icon="action:select-checked"
          size="32"
          class="
            pointer-events-none
            absolute
            left-0
            top-0
            z-2
            transition-[opacity,color]
            duration-[180ms]
            ease-in-out
            ${h({
      "opacity-0": !this.checked,
      "opacity-100": this.checked,
      "text-neutral-090": this.disabled,
      "dark:text-neutral-050": this.disabled,
      "text-red-060": this.invalid,
      "dark:text-red-080": this.invalid,
      "text-blue-060": this.checked && !this.disabled && !this.invalid,
      "hover:text-blue-070": this.checked && !this.disabled && !this.invalid,
      "dark:text-blue-080": this.checked && !this.disabled && !this.invalid,
      "hover:dark:text-blue-070": this.checked && !this.disabled && !this.invalid
    })}
          "
        ></${this.createTagName("-checkbox-icon")}>
      </div>
      <span
        part="label"
        class="
          items-center
          cursor-pointer
          inline-flex
          ${h({
      "text-neutral-090": this.disabled,
      "text-neutral-010": !this.disabled,
      "dark:text-neutral-050": this.disabled,
      "dark:text-neutral-130": !this.disabled
    })}"
      >
        <slot>${this.labelText}</slot>
      </span>
    </label>`;
  }
}
n.styles = [F.styles || [], x(j)];
a([
  V('input[type="checkbox"]')
], n.prototype, "input", 2);
a([
  E()
], n.prototype, "hasFocus", 2);
a([
  E()
], n.prototype, "pristine", 2);
a([
  l({ type: Boolean, reflect: !0 })
], n.prototype, "checked", 2);
a([
  l({ type: Boolean, reflect: !0 })
], n.prototype, "required", 2);
a([
  l({ type: Boolean, reflect: !0 })
], n.prototype, "disabled", 2);
a([
  l({ type: Boolean, reflect: !0 })
], n.prototype, "invalid", 2);
a([
  l({ type: Boolean, reflect: !0 })
], n.prototype, "indeterminate", 2);
a([
  l({ reflect: !0 })
], n.prototype, "orientation", 2);
a([
  l({ attribute: "label-position", reflect: !0 })
], n.prototype, "labelPosition", 2);
a([
  l({ type: String, attribute: "label-text" })
], n.prototype, "labelText", 2);
a([
  l({ type: String })
], n.prototype, "name", 2);
a([
  l({ type: String })
], n.prototype, "value", 2);
a([
  l({ type: Boolean, attribute: "live-validation", reflect: !0 })
], n.prototype, "liveValidation", 2);
a([
  b("disabled", { waitUntilFirstUpdate: !0 })
], n.prototype, "handleDisabledChange", 1);
a([
  b("checked", { waitUntilFirstUpdate: !0 }),
  b("indeterminate", { waitUntilFirstUpdate: !0 })
], n.prototype, "handleStateChange", 1);
try {
  customElements.define("adc-checkbox", n);
} catch {
}
function q(o) {
  try {
    customElements.define(
      `${o}-checkbox`,
      class extends n {
        constructor() {
          super(o);
        }
      }
    );
  } catch {
  }
}
function Q(o) {
  try {
    q(o);
  } catch {
  }
}
export {
  n as Checkbox,
  q as registerCheckbox,
  Q as registerComponent
};
